export const INITIAL_STATE = {
  showNav: true,
  isReadOnly: true
};

const OUAdminEntryContextData = {
  INITIAL_STATE
};

export default OUAdminEntryContextData;